class PvdAnimation {
    constructor(element, property, duration, fps) {
        this.fps = 60;
        this.originalDuration = 1000;
        this.el = element;
        this.property = property;
        this.originalDuration = duration || this.originalDuration;
        this.fps = fps || this.fps;
    }
    // starts animation sequence
    start(destinationVal) {
        // setting the value the user wants by the end of the animation
        this.destinationValue = destinationVal;
        // get the current value
        this.crntValue = parseInt(window.getComputedStyle(this.el)[this.property]) || 0;
        // find the difference between the current value and the destination
        this.distanceToAnimate = this.destinationValue - this.crntValue;
        // are we in the middle of an animation?
        if (this.progress !== undefined) {
            // clear out the timers so we can restart the animation
            this.clear();
            // capture time elapsed and reset the duration
            this.duration = this.progress * this.originalDuration;
        }
        else {
            // use the full duration
            this.duration = this.originalDuration;
        }
        // capture current time
        this.then = Date.now();
        // call the first frame of the animation
        this.frame();
    }
    // Method called on each 'frame' of the animation sequence
    frame() {
        this.rAFTimeout = setTimeout(() => {
            this.tick();
        }, 1000 / this.fps);
    }
    // Method called every frame per second
    // manages when the animation should end based on 'progress' variable
    tick() {
        this.setDelta();
        this.update();
        this.render();
        if (this.progress < 1) {
            this.rAF = window.requestAnimationFrame(() => this.frame());
        }
        else {
            this.end();
        }
    }
    // Calculates time elapsed and progress of the animation
    setDelta() {
        // get current time
        this.now = Date.now();
        // capture seconds since last frame
        this.delta = this.now - this.then;
        // capture progress
        this.progress = this.delta / this.duration;
    }
    // Calculates values in preparation for the render method
    update() {
        const crntProgress = this.easeInOutCube(this.progress) * this.distanceToAnimate;
        this.position = this.crntValue + crntProgress;
    }
    // Modifies style properties on the chart segment
    render() {
        // Render updates to browser (draw to canvas, update css, etc.)
        this.el.style[this.property] = this.position + 'px';
    }
    // Called at the end of the animation cycle.
    // Cancels the rAF and clears the timeout
    end() {
        this.clear();
        // final value
        this.el.style[this.property] = this.destinationValue + 'px';
        // dispatch event that animation finished
        this.dispatchEvent('pvd-animation:end', {
            finalValue: this.destinationValue,
        });
    }
    // cancels animation frame and clears timeout
    clear() {
        window.cancelAnimationFrame(this.rAF);
        clearTimeout(this.rAFTimeout);
    }
    // creates the slower 'ease-in-out' effect when animating
    easeInOutCube(n) {
        n *= 2;
        if (n < 1)
            return 0.5 * n * n * n;
        return 0.5 * ((n -= 2) * n * n + 2);
    }
    /**
     * Dispatches event based off event name
     * @param name, event name
     * @param data, any additional details given about the event
     * @param el, the element that is dispatching the event
     */
    dispatchEvent(name, data, el) {
        // optional element to dispatch events from.  Default to `this.el` reference
        this.el = typeof el !== 'undefined' ? el : this.el;
        const customEvent = new CustomEvent(name, { detail: data });
        // dispatch the event
        this.el.dispatchEvent(customEvent);
    }
}

export { PvdAnimation };
//# sourceMappingURL=animation.js.map
